import { render, staticRenderFns } from "./marketDemand.vue?vue&type=template&id=09ec9826&scoped=true"
import script from "./marketDemand.vue?vue&type=script&lang=js"
export * from "./marketDemand.vue?vue&type=script&lang=js"
import style0 from "./marketDemand.vue?vue&type=style&index=0&id=09ec9826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ec9826",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
